module.exports = __webpack_public_path__ + "static/media/omnilert_logo.7fd032c1.png";